export const INTERNATIONAL_PAYMENT_URL = 'https://remitly.tod8mp.net/kjBYGz';
export const SUITS_ME_REFER = 'https://suitsmecard.com/features/extras/refer';
export const SUITS_ME_APPLY = 'https://apply.suitsmecard.com';
export const SUITS_ME_VIEW_GUIDE =
    'https://support.suitsmecard.com/hc/en-gb/articles/4409812493329';
export const SUITS_ME_MANAGING_GUIDE =
    'https://support.suitsmecard.com/hc/en-gb/articles/4410597249297';
export const SUITS_ME_RESET_PASSWORD =
    'https://support.suitsmecard.com/hc/en-gb/articles/360010999118';
export const SUITS_ME_CONTACT_US = 'https://support.suitsmecard.com/hc/en-gb/requests/new';
export const SUITS_ME_BLOCKED_ACCOUNT =
    'https://support.suitsmecard.com/hc/en-gb/articles/360010999138-Access-to-my-online-banking-account-is-blocked';
export const SUITS_ME_ACTIVATE_DEBIT_CARD =
    'https://support.suitsmecard.com/hc/en-gb/articles/360011830497';
export const SUITS_ME_FINANCIAL_ABUSE =
    'https://suitsmecard.com/support/financial-abuse-support-guide';
export const SUITS_ME_APP_STORE = 'https://apps.apple.com/gb/app/suits-me-banking/id1550972210';
export const SUITS_ME_GOOGLE_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.suitsme.app';
export const SUITS_ME_ABOUT_US = 'https://suitsmecard.com/support/who-are-suitsme';
export const SUITS_ME_SECURITY_POLICY = 'https://suitsmecard.com/security';
export const SUITS_ME_PRIVACY_POLICY = 'https://suitsmecard.com/privacy-policy';
export const SUITS_ME_MONEY_MAKERS = 'https://suitsmecard.com/money_makers';
export const SUITS_ME_TERMS_AND_CONDITIONS = 'https://suitsmecard.com/terms-conditions';
export const SUITS_ME_ACCESSIBILITY = 'https://suitsmecard.com/accessibility';
export const SUITS_ME_TWITTER = 'https://twitter.com/SuitsMeCard';
export const SUITS_ME_FACEBOOK = 'https://www.facebook.com/suitsmecard';
export const SUITS_ME_LINKEDIN = 'https://www.linkedin.com/company/suits-me-card';
export const SUITS_ME_YOUTUBE = 'https://www.youtube.com/watch?v=T5u0w1XC7cM';
export const SUITS_ME_INSTAGRAM = 'https://www.instagram.com/suitsmecard';
export const SUITS_ME_TIKTOK = 'https://www.tiktok.com/@suitsmecard';
export const SUITS_ME_PINTEREST = 'https://www.pinterest.co.uk/suitsmecard';
export const SUITS_ME_EMAIL = 'mailto:hello@suitsmecard.com';
export const SUITS_ME_PHONE = 'tel:0333 0151 858';
export const SUITS_ME_CASHBACK_REWARDS = 'https://suitsmecard.com/features/cashback-rewards';
export const UTM_QUERY = "?utm_source=google_play&utm_medium=app&utm_campaign=app";
export const TRANSFERWISE_CREATE_ACCOUNT = 'https://transferwise.com/terms-of-use';
export const TRANSFERWISE_PRIVACY_POLICY = 'https://transferwise.com/gb/legal/privacy-policy';
export const ACCOUNT_HOLDER_DISCOUNTS = 'https://suitsmecard.com/top-brand-discounts';
